module.exports = __webpack_public_path__ + "media/images/online_icon-4d765c9a1a7692dd1dc27b4417820f93.png";